import service from "@/utils/service"

//列表出菜单 需要验证权限
export function getMenuTree() {
  return service({
    url: "/sys/menu/view",
    method: "get"
  })
}
//添加菜单 需要验证权限
export function createMenu(form) {
  return service({
    url: "/sys/menu/add",
    method: "post",
    data: form
  })
}
//编辑菜单 需要验证权限
export function updateMenu(form) {
  return service({
    url: "/sys/menu/edit",
    method: "post",
    data: form
  })
}
//删除菜单 需要验证权限
export function deleteMenu(form) {
  return service({
    url: "/sys/menu/del",
    method: "post",
    data: form
  })
}
//新建菜单时，下拉选项，配置父节点操作,不需要验证权限
export function getTreeOptions() {
  return service({
    url: "/sys/menu/treeoptions",
    method: "get"
  })
}
